import { motion } from "framer-motion";
import "./PageTransition.css"

const overlayVariants = {
  initial: {
    x: "-100%",
  },
  animate: {
    x: "100%",
    transition: {
      duration: 1.2,
      ease: "easeInOut",
    },
  },
};

const PageTransition = ({ children }) => {
  return (
    <>
      {/* Overlay */}
      <motion.div
        className="page-overlay"
        variants={overlayVariants}
        initial="initial"
        animate="animate"
      />
      
      {/* Page content */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 40 }}
        transition={{ duration: 0.6, ease: "easeInOut", delay: 0.4 }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default PageTransition;
